import styled from '@emotion/styled';
import COLORS from '../../styles/emotion/colors3';

export const VendorIconWrapper = styled.div<{
  iconWidth: number;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${COLORS.BAY_100};
  border-radius: 50%;
  ${({ iconWidth }) => `
    width: ${iconWidth * 2}px;
    height: ${iconWidth * 2}px;
  `};

  svg {
    color: ${COLORS.WHITE_100};
  }
`;
